import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "snack-form" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "py-3 px-4 border-grey-3 rounded-xl shadow-025 lg:flex items-center gap-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "font-bold text-base mb-1 w-full" }
const _hoisted_6 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-2 items-center" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "transaction-type",
  class: "label-text required"
}, "Jenis Transaksi", -1)
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Gedung Asal", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-bold" }, "Detail stok:", -1)
const _hoisted_17 = { class: "stock-detail-list" }
const _hoisted_18 = { class: "text-primary font-bold" }
const _hoisted_19 = { class: "invalid-feedback" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Gedung Tujuan", -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-bold" }, "Detail stok:", -1)
const _hoisted_24 = { class: "stock-detail-list" }
const _hoisted_25 = { class: "text-primary font-bold" }
const _hoisted_26 = { class: "invalid-feedback" }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Jumlah Bundle Snack", -1)
const _hoisted_29 = { class: "invalid-feedback" }
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "Description",
  class: "label-text required"
}, "Keterangan", -1)
const _hoisted_32 = { class: "invalid-feedback" }
const _hoisted_33 = {
  key: 1,
  class: "mb-4 py-3 px-4 border-grey-3 rounded-xl"
}
const _hoisted_34 = { class: "container-btn-action" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Simpan")

import { Form, Field, FieldArray, ErrorMessage } from 'vee-validate'
import * as Yup from 'yup'
import InputNumber from 'primevue/inputnumber'
import Button from 'primevue/button'
import { useStore } from 'vuex'
import { getCurrentInstance, onMounted, ref } from 'vue'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import Dropdown from 'primevue/dropdown'
import rgxExp from '@/utils/helpers/regExp'
import SelectAsyncOpen from '@/views/components/form/SelectAsyncOpen.vue'
import defaulListImage from '@/assets/img/icon/cross-black-background-grey.svg'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import numberFormat from '@/utils/helpers/numberFormat'
import IncreaseStock from '../components/transaction-type-description/IncreaseStock.vue'
import ReduceStock from '../components/transaction-type-description/ReduceStock.vue'
import TransferStock from '../components/transaction-type-description/TransferStock.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageStockForm',
  setup(__props) {

const snackEndpoint = '/ticket/v1/Snacks'
const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const typeOptions = ref([]) as any
const currentData = ref(null) as any
const dataForm = ref()
const currentBuildingDestinationStock = ref(0)
const currentBuildingOriginStock = ref(0)
const currentBuildingOriginStockData = ref(null) as any
const currentBuildingDestinationStockData = ref(null) as any

const initialValues = {
  TransactionType: null,
  DestinationBuilding: null,
  Quantity: null,
  Description: ''
}

const schema = Yup.object().shape({
  TransactionType: Yup.object().required('Jenis Transaksi harus diisi!'),
  Quantity: Yup.number()
    .typeError('Jumlah Snack harus diisi!')
    .required('Jumlah Snack harus diisi!')
    .min(1, 'Jumlah Snack minimal 1')
    .test('maxDigits', 'Jumlah Snack tidak valid', (value) => {
      const valConfert = value.toString()
      if (!valConfert) return true
      const numberRegex = /^\d{1,8}(\.\d{1,2})?$/
      return numberRegex.test(valConfert)
    })
    // eslint-disable-next-line consistent-return
    .test(
      'maxStock',
      'Stok Bundle Snack melebihi stok yang tersedia',
      function (value) {
        const { TransactionType } = this.parent

        if (!value) return true

        if (TransactionType?.Value === 3) {
          return value <= currentBuildingOriginStock.value
        }

        if (TransactionType?.Value === 2) {
          return value <= currentBuildingDestinationStock.value
        }

        return true
      }
    ),
  OriginBuilding: Yup.object()
    .when('TransactionType', {
      // eslint-disable-next-line arrow-body-style
      is: (val: any) => {
        // console.log('val', val)
        return val?.Value === 3
      },
      then: (sch) => sch.required('Gedung Asal harus diisi!'),
      otherwise: (sch) => sch.notRequired()
    }),
  DestinationBuilding: Yup.object().required('Gedung Tujuan harus diisi!'),
  Description: Yup.string()
    .required('Keterangan harus diisi!')
    .matches(rgxExp.notPrefixSpace, 'Keterangan tidak boleh hanya menggunakan spasi.')
    .min(5, 'Keterangan minimal 5 karakter')
    .max(255, 'Keterangan maksimal 255 karakter')
})

const getTransactionTypeOptions = async () => {
  store.dispatch('showLoading')
  try {
    await apiOpenUseCase.get(`${snackEndpoint}/TransactionTypes`).then((response) => {
      const { error, result } = response
      if (!error) {
        typeOptions.value = result.map((data: any, index: any) => {
          if (data.Value === 1) {
            return {
              ...data,
              label: 'Penambahan Stok (+)'
            }
          }
          if (data.Value === 2) {
            return {
              ...data,
              label: 'Pengurangan Stok (-)'
            }
          }
          if (data.Value === 3) {
            return {
              ...data,
              label: 'Transfer Stok'
            }
          }
          return data
        })
      }
    })
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const hideSidebar = () => {
  store.dispatch('setShowModalFormDl', false)
  store.dispatch('storeRowDataTable', null)
}

const processSubmit = async () => {
  store.dispatch('showLoading')
  console.log('dataForm', dataForm.value)
  try {
    const payload = {
      FromBuildingId: dataForm.value?.TransactionType?.Value === 3 ? dataForm.value?.OriginBuilding?.id : null,
      FromBuildingName: dataForm.value?.TransactionType?.Value === 3 ? dataForm.value?.OriginBuilding?.name : null,
      ToBuildingId: dataForm.value?.DestinationBuilding?.id ?? null,
      ToBuildingName: dataForm.value?.DestinationBuilding?.name ?? null,
      TransactionType: dataForm.value?.TransactionType?.Name,
      Quantity: dataForm.value?.Quantity ?? 0,
      Notes: dataForm.value?.Description ?? ''
    }
    await apiOpenUseCase.put(`${snackEndpoint}/${currentData.value?.Id}/Stock`, payload).then((response) => {
      console.log('response', response)
      const { error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          detail: 'Stock Snack Berhasil Diperbarui',
          group: 'bc',
          closable: false,
          life: 3000
        })
        store.dispatch('setReloadDataTable', true)
        hideSidebar()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal',
          detail: message,
          group: 'bc',
          closable: false,
          life: 30000
        })
      }
    })
  } catch (error) {
    console.log('err', error)
  }
  store.dispatch('hideLoading')
}

const onSubmit = (values: any) => {
  console.log('submit', values)
  dataForm.value = values
  processSubmit()
}

const checkBuildingSnackStock = async (val: any) => {
  console.log('val', val)
  store.dispatch('showLoading')
  let snackDataTemp = [] as any
  try {
    const response = await apiOpenUseCase.get(`${snackEndpoint}/ByBuilding/${val.id}`)
    const { error, result } = response
    if (!error) {
      console.log('res', result)
      snackDataTemp = result.filter((data: any) => data.SnackId === currentData.value.Id)
      console.log('snackDataTemp', snackDataTemp)
      return snackDataTemp
    }
    return null
  } catch (err) {
    console.error(err)
    return null
  } finally {
    store.dispatch('hideLoading')
  }
}

const checkBuildingDestinationSnackStock = async (data: any) => {
  const result: any = await checkBuildingSnackStock(data)
  console.log('result', result)
  if (result?.length > 0) {
    console.log('result', result[0])
    currentBuildingDestinationStock.value = result[0].AvailableSnackStock
    currentBuildingDestinationStockData.value = result[0]
  } else {
    currentBuildingDestinationStock.value = 0
    currentBuildingDestinationStockData.value = null
  }
  // console.log('currentBuildingDestinationStock', currentBuildingDestinationStock.value)
}

const checkBuildingOriginSnackStock = async (data: any) => {
  const result: any = await checkBuildingSnackStock(data)
  if (result.length > 0) {
    currentBuildingOriginStock.value = result[0].AvailableSnackStock
    currentBuildingOriginStockData.value = result[0]
  } else {
    currentBuildingOriginStock.value = 0
    currentBuildingOriginStockData.value = null
  }
}

onMounted(() => {
  const titleForm = 'Kelola Stok'
  store.dispatch('setTitleFormSidebarDl', `${titleForm}`)
  currentData.value = store.state.hjpTable.modal?.data
  getTransactionTypeOptions()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _unref(currentData) ? _unref(currentData)?.Image : _unref(defaulListImage),
              alt: "ThumbnailSnack",
              class: "rounded-lg",
              style: {"width":"100px"}
            }, null, 8, _hoisted_4),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(`${_unref(currentData)?.Name} - ${_unref(currentData)?.Code}`), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(rupiahFormat)(_unref(currentData)?.PriceAfterDiscount ?? 0)), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(`Stok Kumulatif: ${_unref(currentData)?.StockCumulative ?? 0}`), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_unref(Field), { name: "TransactionType" }, {
            default: _withCtx(({ handleBlur }) => [
              _createVNode(_unref(Dropdown), {
                optionLabel: "label",
                id: "transaction-type",
                options: _unref(typeOptions),
                placeholder: "Pilih Jenis Transaksi",
                class: "w-full input-custom",
                onBlur: handleBlur,
                onChange: (val) => setFieldValue('TransactionType', val.value),
                modelValue: values.TransactionType,
                "onUpdate:modelValue": ($event: any) => ((values.TransactionType) = $event)
              }, null, 8, ["options", "onBlur", "onChange", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_11, _toDisplayString(errors.TransactionType), 1)
        ]),
        (values.TransactionType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (values.TransactionType?.Value === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_unref(Field), { name: "OriginBuilding" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(SelectAsyncOpen, {
                          placeholder: 'Pilih Gedung Asal',
                          modelValue: values.OriginBuilding,
                          "onUpdate:modelValue": ($event: any) => ((values.OriginBuilding) = $event),
                          id: 'originBuilding',
                          inputId: 'originBuilding',
                          endpoint: "/talent/v1/buildings",
                          classname: 'custom-select',
                          disabled: false,
                          fieldLabel: (v) => `${v.code} - ${v.name}`,
                          clearable: false,
                          searchFields: ['name'],
                          onChange: _cache[0] || (_cache[0] = (val) => checkBuildingOriginSnackStock(val))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                      ]),
                      _: 2
                    }, 1024),
                    (values.OriginBuilding)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("div", null, [
                            _createElementVNode("ul", _hoisted_17, [
                              _createElementVNode("li", null, "Stok Gudang = " + _toDisplayString(_unref(numberFormat)(_unref(currentBuildingOriginStockData)?.SnackStock ?? 0)) + " Pack", 1),
                              _createElementVNode("li", null, "Stok Pending (belum dijual kondektur) = " + _toDisplayString(_unref(numberFormat)(_unref(currentBuildingOriginStockData)?.SnackStockOnHold ?? 0)) + " Pack", 1),
                              _createElementVNode("li", _hoisted_18, "Stok tersedia = " + _toDisplayString(_unref(numberFormat)(_unref(currentBuildingOriginStockData)?.AvailableSnackStock ?? 0)) + " Pack", 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(errors.OriginBuilding), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_unref(Field), { name: "DestinationBuilding" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(SelectAsyncOpen, {
                      placeholder: 'Pilih Gedung Tujuan',
                      modelValue: values.DestinationBuilding,
                      "onUpdate:modelValue": ($event: any) => ((values.DestinationBuilding) = $event),
                      id: 'destinationBuilding',
                      inputId: 'destinationBuilding',
                      endpoint: "/talent/v1/buildings",
                      classname: 'custom-select',
                      disabled: false,
                      fieldLabel: (v) => `${v.code} - ${v.name}`,
                      clearable: false,
                      searchFields: ['name'],
                      onChange: _cache[1] || (_cache[1] = (val) => checkBuildingDestinationSnackStock(val))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                  ]),
                  _: 2
                }, 1024),
                (values.DestinationBuilding)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", null, [
                        _createElementVNode("ul", _hoisted_24, [
                          _createElementVNode("li", null, "Stok Gudang = " + _toDisplayString(_unref(numberFormat)(_unref(currentBuildingDestinationStockData)?.SnackStock ?? 0)) + " Pack", 1),
                          _createElementVNode("li", null, "Stok Pending (belum dijual kondektur) = " + _toDisplayString(_unref(numberFormat)(_unref(currentBuildingDestinationStockData)?.SnackStockOnHold ?? 0)) + " Pack", 1),
                          _createElementVNode("li", _hoisted_25, "Stok tersedia = " + _toDisplayString(_unref(numberFormat)(_unref(currentBuildingDestinationStockData)?.AvailableSnackStock ?? 0)) + " Pack", 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_26, _toDisplayString(errors.DestinationBuilding), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_unref(Field), {
                  name: "Quantity",
                  class: _normalizeClass(`${errors.Quantity ? 'input-invalid' : ''}`)
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_unref(InputNumber), {
                      modelValue: values.Quantity,
                      "onUpdate:modelValue": ($event: any) => ((values.Quantity) = $event),
                      class: _normalizeClass(["w-full", `${errors.Quantity ? 'input-invalid' : ''}`]),
                      id: "Quantity",
                      placeholder: "0",
                      min: 0,
                      locale: "id-ID",
                      step: 0.25,
                      inputId: "refund-amount",
                      onInput: (v) => {
                setFieldValue('Quantity', v.value)
              },
                      onBlur: field.onBlur,
                      allowEmpty: false,
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["class"]),
                _createElementVNode("div", _hoisted_29, _toDisplayString(errors.Quantity), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_unref(Field), {
                  id: "Description",
                  name: "Description",
                  as: "textarea",
                  type: "text",
                  placeholder: "Tulis Keterangan",
                  class: _normalizeClass(`${errors.Description ? 'input-invalid' : ''}`),
                  modelValue: values.Description,
                  "onUpdate:modelValue": ($event: any) => ((values.Description) = $event),
                  validateOnInput: true
                }, null, 8, ["class", "modelValue", "onUpdate:modelValue"]),
                _createElementVNode("div", _hoisted_32, _toDisplayString(errors.Description), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (values.TransactionType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              (values.TransactionType?.Value === 1)
                ? (_openBlock(), _createBlock(IncreaseStock, { key: 0 }))
                : _createCommentVNode("", true),
              (values.TransactionType?.Value === 2)
                ? (_openBlock(), _createBlock(ReduceStock, { key: 1 }))
                : _createCommentVNode("", true),
              (values.TransactionType?.Value === 3)
                ? (_openBlock(), _createBlock(TransferStock, { key: 2 }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_35
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            id: "Submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})